<template>
  <Tag class="TagMatchScore lg" :class="theme">
    {{ $t('score', [score]) }}
  </Tag>
</template>

<script>
export default {
  props: {
    score: { type: Number, required: true },
  },
  computed: {
    theme() {
      const { score } = this

      if (score >= 7) {
        return 'success'
      } else if (score >= 5.5) {
        return 'success light'
      } else if (score >= 5) {
        return 'info light'
      } else if (score >= 3.5) {
        return 'warning light'
      } else {
        return 'danger light'
      }
    },
  },
}
</script>

<style lang="scss">
.TagMatchScore {
}
</style>

<i18n>
{
  "en": {
    "score": "Similarity: {0}"
  }
}
</i18n>
